<div class="component-viewer mat-elevation-z2 m-2 h-100">
    <div *ngIf="isLoading && !hasSigned" class="m-3 m-md-4">
        <ejs-message id="msg_info" content="Digital Waiver is loading..." severity="Info"></ejs-message>
    </div>
    <div *ngIf="hasError" class="m-3 m-md-4">
        <ejs-message id="msg_error" content="There was an error loading the Digital Waiver" severity="Error"></ejs-message>
    </div>
    <div *ngIf="hasSubmissionError" class="m-3 m-md-4">
        <ejs-message id="msg_error" content="There was an error submitting your Digital Waiver" severity="Error"></ejs-message>
    </div>
    <div class="container-fluid px-2 px-md-4">
        <div class="row">
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </div>
        <form [formGroup]="form" (ngSubmit)="submit()" *ngIf="!isLoading && !hasError && !hasSubmissionError && !hasSigned">
            <h2  class="mb-3 mb-md-4 fs-4 fs-md-3">{{activeDigitalWaiver?.title}} - Digital Waiver</h2>
            <div class="mb-3 mb-md-4">
                <div class="row g-2">
                    <div class="col-12 col-md-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>First Name</mat-label>
                            <input matInput formControlName="firstName" required>
                            <mat-error *ngIf="form.get('firstName')?.errors?.required">First Name is
                                required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="lastName" required>
                            <mat-error *ngIf="form.get('lastName')?.errors?.required">Last Name is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Email Address</mat-label>
                            <input matInput formControlName="emailAddress" required type="email">
                            <mat-error *ngIf="form.get('emailAddress')?.errors?.required">Email is required</mat-error>
                            <mat-error *ngIf="form.get('emailAddress')?.errors?.email">Please enter a valid email
                                address</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <h3 class="mat-h3 fs-5 fs-md-4 mb-2 mb-md-3">Legal Information</h3>
                    <div class="legal-terms-container">
                        <div class="legal-terms-content" [innerHTML]="activeDigitalWaiver?.legalTerms"></div>
                    </div>
                </div>
            </div>

            <div class="row mt-3 mt-md-4">
                <div class="col-12">
                    <h3 class="mat-h3 fs-5 fs-md-4 mb-2 mb-md-3">Signature</h3>
                    <div>
                        <canvas ejs-signature #signatureObj id="signature" [strokeColor]="strokeColor"
                            [backgroundColor]="backgroundColor" (change)="onSignatureChange()"></canvas>
                        <div class="d-flex justify-content-end mt-2">
                            <button mat-button type="button" (click)="clearSignature()">Clear</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-3 mt-md-4 mb-4">
                <div class="col-12">
                    <div class="d-flex justify-content-end">
                        <button mat-raised-button type="submit"
                            [disabled]="!form.valid || !hasSignature"
                            class="w-100 w-md-auto">
                            Submit Waiver
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="isSubmitting" class="m-3 m-md-4">
                <ejs-message id="msg_info" content="Submitting Digital Waiver..." severity="Info"></ejs-message>
            </div>
        </form>
        <div *ngIf="hasSigned" class="m-3 m-md-4">
            <ejs-message id="msg_warning" content="Your Digital Waiver has been signed" severity="Success"></ejs-message>
        </div>
    </div>
</div>